import { render, staticRenderFns } from "./PagePhrases.vue?vue&type=template&id=15530d10&scoped=true&"
import script from "./PagePhrases.vue?vue&type=script&lang=js&"
export * from "./PagePhrases.vue?vue&type=script&lang=js&"
import style0 from "./PagePhrases.vue?vue&type=style&index=0&id=15530d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15530d10",
  null
  
)

export default component.exports